// extracted by mini-css-extract-plugin
export default {"recencyTag":"SpaceRecencyTag_recencyTag_3cQEc","small":"SpaceRecencyTag_small_P-14K","recencyArrow":"SpaceRecencyTag_recencyArrow_2vSaG","large":"SpaceRecencyTag_large_2R6C4"};